import Icon from '@components/v2/ui/Icon/Icon';
import MenuItem from '@components/v2/ui/Menu/MenuItem';
import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import { ElementType } from 'react';
import LangEnum from '../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../modules/translation/TranslationContext';

interface MassActionsBarMenuItemProps {
  icon: ElementType;
  label: LangEnum;
  onClick: () => void;
}

export function MassActionsBarMenuItem({ icon, label, onClick }: MassActionsBarMenuItemProps) {
  const { translate } = useTranslation();

  return (
    <MenuItem onClick={onClick}>
      <Stack direction="row" sx={{ alignItems: 'center', gap: 1 }}>
        <Icon icon={icon} size="md" />
        <Typography variant="body2">{translate(label)}</Typography>
      </Stack>
    </MenuItem>
  );
}
